import type { ReactNode } from 'react';

import { PrimaryCta } from './DrawerPrimaryCta';

export function DrawerFooter({
  cur,
  count,
  ctaLabel,
  canContinue,
  continueAlwaysEnabled,
  renderFinalCta,
  onCancel,
  onCta,
  go,
  footNote,
}: {
  cur: number;
  count: number;
  ctaLabel: string;
  canContinue: boolean;
  continueAlwaysEnabled?: boolean;
  renderFinalCta?: (canContinue: boolean) => ReactNode;
  onCancel?: () => void;
  onCta?: () => void;
  go: (i: number) => void;
  footNote?: ReactNode;
}) {
  const isLast = cur === count - 1;
  // In the always-enabled model (B2) the intermediate Continue ignores
  // `canContinue` (validation happens on click); the final-step CTA still
  // honors it so the consumer can disable it while submitting.
  const enabled = isLast || !continueAlwaysEnabled ? canContinue : true;
  return (
    <footer className="nb-cdrawer-ft">
      <div className="nb-cdrawer-ftnote">
        {`Step ${cur + 1} of ${count}`}
        {footNote ? ' · ' : ''}
        {footNote || ''}
      </div>
      <button className="nb-cdrawer-btn" onClick={onCancel}>
        Cancel
      </button>
      {cur > 0 && (
        <button className="nb-cdrawer-btn nb-cdrawer-btn--secondary" onClick={() => go(cur - 1)}>
          Back
        </button>
      )}
      {isLast && renderFinalCta ? (
        renderFinalCta(canContinue)
      ) : (
        <PrimaryCta
          enabled={enabled}
          isLast={isLast}
          ctaLabel={ctaLabel}
          onCta={onCta}
          goNext={() => go(cur + 1)}
        />
      )}
    </footer>
  );
}
